//  findNearestSatellite();


import UtilSP from "SATPROF_UTILS/UtilSP"; 
import * as THREE from 'three';
import ThreeFontService from "SATPROF_LIBRARY/DropinSupervisor/services/three-font-service"; // Needed for 3D text
import Earth1_grp from "SATPROF_LIBRARY/Earth1/Earth1_grp";
import Constellations3_grp from "SATPROF_LIBRARY/Cosmos3/Constellations3_grp";
import TimingInfo from 'SATPROF_LIBRARY/DropinSupervisor/timing-info';
import { Sprite } from "@awayjs/scene";

export default class Cosmos3_grp  extends THREE.Group{
    public earth : Earth1_grp;
    public con : Constellations3_grp;
    public timer:TimingInfo;
    public timeAccelFactor:number = 1000;
    //protected _tElapsedReal : number = 0;

    protected _tScaledNow:number = 0;  
    public tScaledLast:number = 0;
    protected tElapsedLast:number = 0;

    private _secondsSinceMasterEpoch:number; // Physics time in seconds since the master epoch (Year 0 AD)
    private _secondsSinceMasterEpoch_last:number; //
    private Tdisp:number; // Displayed time in seconds (from timer)
    private Tdisp_last:number;


    public earthLongAtXequalsZero:number = 0; 
    public earthRotR:number;
    public helper1:THREE.AxesHelper;
    public helper2:THREE.AxesHelper;
     private _activeSatelliteGroupNo:number = 0;
    private _activeSatelliteSatNo:number = 0;

    constructor(){
        super();
        //var group1 = new THREE.Group();
        console.log("In Cosmos3_grp constructor ");

        this.earth = new Earth1_grp();
        this.earth.showBeam = false;
        this.earth.showLatTexts = false;
        this.earth.showLatLines = false;
        this.earth.latLineColor = "orange";
        this.earth.equatorColor = "orange";
        this.earth.longLineColor = "green";
        this.earth.cursorLineLineColor = "purple";
        this.earth.PMColor = "green";
        this.earth.siteColor = "purple";
        this.earth.siteSize = 50;
        this.earth.siteBlink = true;

        this.add( this.earth );

        this.tScaledLast = 2021 * UtilSP.calendarYear_sec;

        this.con = new Constellations3_grp();  
        this.add( this.con );   
   
        this.helper1 = new THREE.AxesHelper(1000);
        this.helper2 = new THREE.AxesHelper(2000);
        //this.add( this.helper1 );   
        //this.add( this.helper2 ); 
        //let cosmicHelper:THREE.AxesHelper = new THREE.AxesHelper(20000);
        //this.add(cosmicHelper);
        
        this.timer = new TimingInfo();  
        this.initializeSystem();
    }


    public doEveryFrame(){
        //console.log("In doEveryFrame. xxx"+ this._tScaledNow);
        //----------------------------------------------------
        // Do every frame stuff here.
        this.updateSystem();



        //----------------------------------------------------       
    }
    public initializeSystem(){
        this._secondsSinceMasterEpoch = 0; ///2021 * UtilSP.calendarYear_sec;
        this._secondsSinceMasterEpoch_last = this._secondsSinceMasterEpoch;
        this.Tdisp = this.timer.elapsedTime;
        this.Tdisp_last = this.Tdisp;
        this.timer.reset();
    }
    public updateSystem(){

        this.updateTimes();

        this.earthRotR = 2*Math.PI * this._secondsSinceMasterEpoch / UtilSP.siderealDay_sec; // Rotation in sidereal space
        let earthRotAtAD0_deg = 0; ///-93;  // Adjust to put prime meridian on the sideral x axis.  Earth1 has its prime meridian on its X axis 
        this.earthRotR += UtilSP.radians(earthRotAtAD0_deg);        
        this.earthRotR = UtilSP.mod2Pi(this.earthRotR);
        this.earth.rotation.y = this.earthRotR;
        this.earth.doEveryFrame();

        this.con.secondsSinceMasterEpoch = this._secondsSinceMasterEpoch;
        this.con.doEveryFrame();

        this.earthLongAtXequalsZero = UtilSP.degrees(this.earthRotR);
    }
  
    public updateTimes(){
		// Must be called every frame.
        let TdispStep:number = this.timer.elapsedTime - this.Tdisp_last;
        let TmStep:number = TdispStep *  this.timeAccelFactor;
        this._secondsSinceMasterEpoch = this._secondsSinceMasterEpoch_last + TmStep;

        this._secondsSinceMasterEpoch_last = this._secondsSinceMasterEpoch; // Save for next time
        this.Tdisp_last = this.timer.elapsedTime;

        // let tElapsedStep:number = this.timer.elapsedTime - this.tElapsedLast;
        // let tScaledStep = tElapsedStep * this.timeAccelFactor;
        // this._tScaledNow = this.tScaledLast + tScaledStep;
        // this.tScaledLast = this._tScaledNow;
        // this.tElapsedLast = this.timer.elapsedTime;
        //console.log("Inc Cosmos3_grp, this.timer.elapsedTime = "+this.timer.elapsedTime+", this._tScaledNow = "+this._tScaledNow);

    }
    public resetTimer(){
        this.timer.reset();
    }
    public set tScaledNow(val:number){
        this._tScaledNow = val;
        this.tScaledLast = val;
        this.tElapsedLast = this.timer.elapsedTime;
    }
    public get tScaledNow():number{
        return this._tScaledNow;
    }
    public pause(val?:number){
        if (val){
            this.timer.pauseAtElasedTime(val);
        } else {
            this.timer.pause();
        }
    }
    public resume(){
        this.timer.resume();
    }
    public get elapsedTime():number{
        return this.timer.elapsedTime;
    }
    
    public set activeSatelliteGroupNo(val:number){
        this._activeSatelliteGroupNo = val;
    }
    public get activeSatelliteGroupNo():number{
        return this._activeSatelliteGroupNo;
    }    
    public set activeSatelliteSatNo(val:number){
        this._activeSatelliteSatNo = val;
    } 
    public get activeSatelliteSatNo():number{
        return this._activeSatelliteSatNo;
    }
    public get secondsSinceMasterEpoch():number{
        return this._secondsSinceMasterEpoch;
    }    
}


